import { render, staticRenderFns } from "./SurveyEditor.vue?vue&type=template&id=fbcd41da&scoped=true"
import script from "./SurveyEditor.vue?vue&type=script&lang=js"
export * from "./SurveyEditor.vue?vue&type=script&lang=js"
import style0 from "./SurveyEditor.vue?vue&type=style&index=0&id=fbcd41da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbcd41da",
  null
  
)

export default component.exports